import { render } from "./createPriceTableConfigComponent.vue?vue&type=template&id=54610425&scoped=true"
import script from "./createPriceTableConfigComponent.vue?vue&type=script&lang=js"
export * from "./createPriceTableConfigComponent.vue?vue&type=script&lang=js"

import "./createPriceTableConfigComponent.vue?vue&type=style&index=0&id=54610425&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54610425"]])

export default __exports__